// extracted by mini-css-extract-plugin
export default {"divIntro":"LandingPage_divIntro__f5wWc","logo":"LandingPage_logo__5nlqb","buttonContainer":"LandingPage_buttonContainer__WV0bw","sendButtonP":"LandingPage_sendButtonP__NPGz5"};